import InstancesOnBehalf from './InstancesOnBehalf';

export default InstancesOnBehalf;